import React from 'react';
import './App.css';
import Home from './pages/Home';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import { Routes, Route, useLocation } from 'react-router-dom';
import Projects from './pages/Projects/Projects';
import MultiAgent from './pages/Projects/MultiAgent';
import Bioinformatics from './pages/Bioinformatics/Bioinformatics';
import AgentScientist from './pages/AgentScientist/AgentScientist';
import Events from './pages/Events/Events';
import SciSprint2026 from './pages/SciSprint2026';
import Notfound from './components/notfound/Notfound';

function App() {
  const location = useLocation();
  const isBioinformatics = location.pathname.startsWith('/learn/bioinformatics');
  const isEvents = location.pathname.startsWith('/events') || location.pathname === '/scisprint-2026';

  return (
    <>
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/agent-scientist' element={<AgentScientist />} />
        <Route path='/events' element={<Events />} />
        <Route path='/events/scisprint-2026' element={<SciSprint2026 />} />
        <Route path='/scisprint-2026' element={<SciSprint2026 />} />
        <Route path='/learn' element={<Projects />} />
        <Route path='/learn/multi-agent' element={<MultiAgent />} />
        <Route path='/learn/bioinformatics' element={<Bioinformatics />} />
        <Route path="*" element={<Notfound />} />
      </Routes>
      {!isBioinformatics && !isEvents && <Footer />}
    </>
  );
}

export default App;
